import React from 'react';

import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';
import { CaseSources } from 'src/utils/jmrUtils';

import PlacementCardLayout from './placementCardLayout';
import PlacementInfo from './placementInfo';

interface TransferredInPlacementCardProps {
  placement: AssociateProfilePlacement;
}

const TransferredInPlacementCard = ({ placement }: TransferredInPlacementCardProps) => {
  return (
    <PlacementCardLayout placement={placement}>
      <PlacementInfo
        label="Injury"
        value={placement.injury}
        tooltip={placement.accommodationType === CaseSources.Dali ? 'DALI injury location not available' : undefined}
      />
      <PlacementInfo label="Transferred from" value={placement.transferredFrom} />
      <PlacementInfo label="Transfer Date" value={new Date(placement.transferAt).toLocaleDateString()} />
      <PlacementInfo label="Time In Transfer" value={placement.timeInStatus} />
      <PlacementInfo label="Transferred By" value={placement.updatedBy} />
    </PlacementCardLayout>
  );
};

export default TransferredInPlacementCard;
